export const STAIR_TYPE_FIXED = 'speprice'
export const STAIR_TYPE_RATIO = 'speratio'
export const STAIR_TYPES = [
  {id: STAIR_TYPE_FIXED, name: '指定金额'},
  {id: STAIR_TYPE_RATIO, name: '百分比上浮'}
]
export const STAIR_TYPE_MAP = STAIR_TYPES.reduce((map, obj) => {
  map[obj.id] = obj.name
  return map
}, {})

// 每年最多设置的阶梯单价数量
export const STAIR_MAX_PER_YEAR = 8
export const STAIR_MAX_LIMIT = 99999



// WEBPACK FOOTER //
// ./src/sysmodule/waterfee/constants.js